const idmServerPrefix = '/api'

export default {
  treeUrl: idmServerPrefix + '/category/getCategoryTreeByKey', // 目录树地址
  roles: { // 角色
    parentId: '-1', // 角色管理顶级id
    rolesTreeUrl: idmServerPrefix + '/baseRole/getRoleTree', // 角色树地址
    rolesListUrl: idmServerPrefix + '/baseRole/getRoleList', // 角色列表
    addUrl: idmServerPrefix + '/baseRole/addRole', // 新增
    editUrl: idmServerPrefix + '/baseRole/updateRole', // 编辑
    deleteUrl: idmServerPrefix + '/baseRole/deleteRole', // 删除
    rolesToPersonUrl: idmServerPrefix + '/baseRole/assignUser2Role', // 角色授权多人
    rolesToUnitUrl: idmServerPrefix + '/baseRole/saveOrgRelation', // 角色单位数据权限分配
    rolesRemovePersonUrl: idmServerPrefix + '/baseRole/deleteUser2Role', // 移除角色授权多人
    rolesAlreadyToPersonUrl: idmServerPrefix + '/baseRole/getRoleAndUserByRoleId', // 已授角色人员
    rolesToResourcesUrl: idmServerPrefix + '/baseRole/assignResourceToRole', // 角色添加资源
    rolesAlreadyToResourcesUrl: idmServerPrefix + '/baseRole/getResourceIdByRoleId' // 已给角色添加的资源
  },
  organization: { // 组织
    parentId: '-1', // 组织管理顶级id
    organizationTreeUrl: idmServerPrefix + '/admOrg/getAdmOrgTree' // 组织树地址
  },
  person: { // 人员
    getPersonListUrl: idmServerPrefix + '/baseUser/getUserListNoPage' // 获得无分页的人员列表
  },
  resources: { // 资源
    parentId: '-1', // 树顶级id
    TreeUrl: idmServerPrefix + '/resource/getResourceTree', // 树地址
    ListUrl: idmServerPrefix + '/resource/getResourceList', // 列表
    resourceToRolesUrl: idmServerPrefix + '/resource/saveResourceToRole', // 资源分配给角色
    resourceAlreadyToRolesUrl: idmServerPrefix + '/resource/getRoleIdByResourceId', // 已分配给角色的资源
    addUrl: idmServerPrefix + '/resource/addResource', // 新增
    editUrl: idmServerPrefix + '/resource/updateResource', // 编辑
    deleteUrl: idmServerPrefix + '/resource/deleteResource', // 删除
  },
  ukManage: { // uk管理
    ListUrl: idmServerPrefix + '/ukManage/getUkList', // 列表
    addUrl: idmServerPrefix + '/ukManage/addUk', // 新增
    deleteUrl: idmServerPrefix + '/ukManage/delUk', // 删除
  },

  workFlowUrl: idmServerPrefix + '/develop/flow/instance', // 流程提交地址
  workFlowPdfUrl: idmServerPrefix + '/caService/showPdf/instance', // Pdf流程提交地址
  workFlowCaUrl: idmServerPrefix + '/caService/showPdf/instanceByCa', // Ca流程提交地址

  //决定是否显示抄送功能（某些项目里面不需要）
  isHaveCopyDo:true,
  isHaveChangeStyle: false,
  isShowDefaultItemData: false,
  isShowWarn: true,//是否显示消息
  isShowDb:false
}



//////////////////
// WEBPACK FOOTER
// ./config/base-config.js
// module id = null
// module chunks = 